import type { MetaMatchKeys } from './metaLead';
import { hashValue } from '@/utils/enhancedConversions';

export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

export const pageview = () => {
  window.fbq('track', 'PageView');
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
const sentLeads = new Set<string>();

/**
 * The browser half of a Lead, at most once per event id however often the success view
 * re-renders. With match keys it first re-initialises the pixel with them hashed (advanced
 * matching), as the Tag Manager tag used to, so the pixel never sees them in plain text.
 */
export const lead = async (eventId: string, keys: MetaMatchKeys = {}) => {
  if (!eventId || sentLeads.has(eventId)) return;
  sentLeads.add(eventId);

  const pixelId = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
  if (typeof window.fbq === 'function' && pixelId && (keys.em || keys.ph)) {
    try {
      const hashed = Object.fromEntries(
        await Promise.all(
          Object.entries(keys)
            .filter(([, value]) => value)
            .map(async ([key, value]) => [key, await hashValue(value as string)]),
        ),
      );
      window.fbq('init', pixelId, hashed);
    } catch {
      // Matching is a bonus; the Lead itself must still go.
    }
  }

  event('Lead', {}, eventId);
};

export const event = (name: string, options: Record<any, any> = {}, eventId?: string) => {
  // The pixel may be blocked or not loaded yet; a lead must never fail on it.
  if (typeof window.fbq !== 'function') return;
  window.fbq('track', name, options, eventId ? { eventID: eventId } : undefined);
};
